import React, { useEffect, useState } from 'react';
import {
    Link
} from "react-router-dom";
import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';
import Minibar from '../../../components/navbar/Minibar';

function Document(props) {
    const [document_info, setDocument_info] = useState({
        selected_all: false,
        control_folder: false,
        control_file: false,
        step_back: 'documents',
        current_path: 'documents',
        doc_list: []
    });

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const isBackDisabled = document_info.current_path === "documents";

    useEffect(() => {
        api_dcuments_browse('documents')
        return () => {
            setDocument_info({
                selected_all: false,
                control_folder: false,
                control_file: false,
                step_back: 'documents',
                current_path: 'documents',
                doc_list: []
            });
        }
    }, []);

    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(confirmcode) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    async function api_dcuments_browse(current_path) {
        const formData = new FormData()
        formData.append('current_path', current_path)
        formData.append('sitelist', props.permitdata.sitescope_str)
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/documents/files/browse", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.data !== null && response.data.data !== undefined) {
                    setDocument_info(response.data.data)
                }
            })
            .catch((err) => {
                setDocument_info({
                    selected_all: false,
                    control_folder: false,
                    control_file: false,
                    step_back: 'documents',
                    current_path: 'documents',
                    doc_list: []
                });
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function api_click_folder(isdir, pathname) {
        if (isdir === true) {
            api_dcuments_browse(pathname)
        }
    }

    function open_pdf(timestamp, file_link) {
        let url = process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/documents/files/reader?ts=" + timestamp + "&&filename=" + file_link
        window.open(url, "_blank")
    }


    function download_pdf(timestamp, file_link, file_name) {
        let url = process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/documents/files/download?ts=" + timestamp + "&&filename=" + file_link
        const link = document.createElement("a");
        link.href = url
        link.download = file_name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    function get_file_icon(ext) {
        if (ext === ".pdf") {
            return 'mdi mdi-file-pdf-outline file-color-pdf  me-2'
        } else if (ext === ".xls" || ext === ".xlsx") {
            return 'mdi mdi-file-excel-outline file-color-excel  me-2'
        } else if (ext === ".doc" || ext === ".docx") {
            return 'mdi mdi-file-word-outline file-color-word  me-2'
        } else if (ext === ".ppt" || ext === ".pptx") {
            return 'mdi mdi-file-powerpoint-outline file-color-ppt  me-2'
        } else if (ext === ".csv") {
            return 'mdi mdi-file-delimited-outline file-color-csv  me-2'
        } else if (ext === ".txt") {
            return 'mdi mdi-file-outline file-color-txt  me-2'
        } else if (ext === ".dwg") {
            return 'mdi mdi-file-cad file-color-dwg  me-2'
        } else if (ext === ".jpg" || ext === ".jpeg" || ext === ".png" || ext === ".bmp") {
            return 'mdi mdi-file-image-outline file-color-image  me-2'
        } else if (ext === "folder") {
            return 'mdi mdi-folder file-color-folder me-2'
        } else if (ext === ".exe" || ext === ".msi") {
            return 'mdi mdi-file-cog file-color-unknown me-2'
        }
        return 'mdi mdi-file-outline file-color-unknown  me-2'
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }


    return (
        <section id="content" className="content">
            <Minibar
                main_root={"Documents"}
                submenu_root={"Project Documents"}
                systemtime={props.data_systemdatetime}
            />
            <div className="content__boxed d-md-flex h-100">
                <div className="content__wrap order-2 flex-fill min-w-0">
                    <div id="page-content">
                        <div className="panel">
                            <div className="panel-body">
                                <div className="row mb-2">
                                    <div className="col-xl-12">
                                        <div className='d-flex justify-content-between'>
                                            <div>
                                                <h4 className="mb-1"><i className="fas fa-file-alt color-orange"></i> Project Documents</h4>
                                                <p className="mb-0">Collection our project documents</p>
                                            </div>
                                            <div>
                                                {BackCenter()}
                                            </div>
                                        </div>
                                        <hr className="new-section-xs mb-1" />
                                        <div className="d-flex justify-content-start gap-3 mt-2">
                                            <button className="btn btn-info btn-sm" type="button" onClick={() => { api_dcuments_browse(document_info.step_back) }} disabled={isBackDisabled}><i className="fa fa-arrow-left me-2"></i> Back</button>
                                            <button className="btn btn-success btn-sm" type="button" onClick={() => { api_dcuments_browse(document_info.current_path) }} ><i className="fas fa-sync-alt me-2"></i> Refresh</button>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-3 mb-1 mb-md-4">
                                    <h5>Document Path : {document_info.current_path} ....... (found {document_info.doc_list.length} items)</h5>
                                    <div className="table-responsive">
                                        <table className="table table-striped table-bordered text-nowrap" >
                                            <thead>
                                                <tr className="admintable-header">
                                                    <th>No.</th>
                                                    <th>Name</th>
                                                    <th>Date Modify</th>
                                                    <th className="text-center" style={{ width: "100px" }}>....</th>
                                                </tr>
                                            </thead>
                                            <tbody >
                                                {
                                                    document_info.doc_list.map((data, index) => (
                                                        <tr key={index}>
                                                            <td width={'50px'}>{index + 1}</td>
                                                            <td><div className={data.is_dir ? 'file-items-browser file-cursor' : "file-items-browser"} onClick={() => { api_click_folder(data.is_dir, data.current_path + '/' + data.name) }}><i className={get_file_icon(data.extension)} style={{ fontSize: "16px" }}></i> {data.name} {data.detail}</div></td>
                                                            <td width={'150px'}>{data.modify_time}</td>
                                                            <td width={'100px'}>
                                                                {data.is_dir === true ?
                                                                    <Link className="btn btn-sm btn-hover btn-bordered" title="Open Directory" onClick={() => { api_dcuments_browse(data.current_path + '/' + data.name) }}><i className='fa fa-search'></i></Link>
                                                                    :
                                                                    <>
                                                                        <Link className="btn btn-sm btn-hover btn-bordered" title="View File" onClick={() => { open_pdf(data.timestamp, data.file_link) }}><i class="fa fa-search"></i></Link>
                                                                        <Link className="btn btn-sm btn-hover btn-bordered mx-1" title="Download" onClick={() => { download_pdf(data.timestamp, data.file_link, data.name) }}><i className='fa fa-download'></i></Link>
                                                                    </>
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
                {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
            </div>
        </section>

    )
}
export default Document